import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useClearTermsOfServiceAckMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: Api.ITermsOfServiceAck) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async () => {
			const result = await userSession.webServiceHelper.callAsync<Api.ITermsOfServiceAck>(
				'termsOfService',
				'POST',
				null
			);
			return result as Api.ITermsOfServiceAck;
		},
		onError,
		onSuccess,
	});
}
